import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { useState } from "react";
import classes from "../Accordion.module.css";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MessagingDetailsCard from "../../Cards/MessagingDetailsCard/MessagingDetailsCard";
import MessagingDetailsContentCard from "../../Cards/MessagingContentCard/MessagingDetailsContentCard";

const MessagingAccordion = (props) => {
  const [expanded, setExpanded] = useState(props?.expanded ? props?.expanded : false);

  const handleChange = (event, newExpanded) => {
    setExpanded(newExpanded);
  };

  return (
    <div className={classes.cardContainer}>
      <Accordion
        expanded={expanded}
        onChange={handleChange}
        className={classes.accordion}
      >
        <AccordionSummary
          aria-controls={props?.id}
          id={props?.id}
          className={classes.accordionSummary}
          expandIcon={<ExpandMoreIcon />}
        >
          <MessagingDetailsCard
            {...props}
          /> 
        </AccordionSummary>

        <AccordionDetails className={classes.accordionDetails}>
          <MessagingDetailsContentCard {...props} />
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default MessagingAccordion;
